import { Controller } from "@hotwired/stimulus"

// Submits the enclosing form when a control changes (filter selects). Replaces inline
// onchange="this.form.requestSubmit()" handlers, which the Content Security Policy forbids.
export default class extends Controller {
  submit() { this.element.form?.requestSubmit() }
}
